import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-452e57bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progressbar-wrapper" }
const _hoisted_2 = { class: "" }

import { useClientStore } from '@/store/client';
import { useUserStore } from '@/store/user';
import Tariff from '@/types/Tariff';
import TariffAttribute from '@/types/TariffAttribute';
import { computed,ref } from 'vue';

const COUNT_CLIENTS_KEY = 'countClients';
const enum PROGRESSBAR_CLASSES {
  PRIMARY = 'primary',
  WARNING = 'warning',
  ERROR = 'error'
}
const MAX_PERCENT = 100;
const MAX_FREE_SLOTS = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientsTariffProgressbar',
  props: {
  height: {
    type: Number,
    default: 10
  }
},
  setup(__props) {

const clientStore = useClientStore();
let userStore = useUserStore();
const progressBarClass = ref(PROGRESSBAR_CLASSES.PRIMARY);
const current = computed(() => clientStore.getClients.length);

const max = ref(0);

userStore.tariffOrganization().then((tariff: Tariff) => {
  const cntClientsAttribute: TariffAttribute = tariff.attributes.find((ta) => ta.key === COUNT_CLIENTS_KEY)!;
  max.value = Number(cntClientsAttribute.value);
});



const calcProgressbarValue = computed(() => {
  buildClassProgressbar();
  return (current.value * MAX_PERCENT) / max.value;
});

function buildClassProgressbar() {
  const freeSlots = max.value - current.value;
  if (freeSlots <= 0) {
    progressBarClass.value = PROGRESSBAR_CLASSES.ERROR;
  } else if (freeSlots <= MAX_FREE_SLOTS) {
    progressBarClass.value = PROGRESSBAR_CLASSES.WARNING;
  } else {
    progressBarClass.value = PROGRESSBAR_CLASSES.PRIMARY;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(current.value) + " / " + _toDisplayString(max.value), 1),
    _createVNode(_component_v_progress_linear, {
      rounded: "",
      color: progressBarClass.value,
      height: __props.height,
      modelValue: calcProgressbarValue.value
    }, null, 8, ["color", "height", "modelValue"])
  ]))
}
}

})